// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3qhkZ","upload":"Small_upload__2d3Pj","imageWrap":"Small_imageWrap__1HC24","removeBtn":"Small_removeBtn__2fDox"};